import axios from 'axios';

export default class InspirationListing {
  constructor() {
    this.$el = document.querySelector('.js-inspiration-listing');
    if (!this.$el) return;

    this.currentPage = 1;

    this.$header = document.querySelector('.js-header');
    this.$loadMoreButton = this.$el.querySelector('.js-inspiration-listing-load-more');
    this.$grid = this.$el.querySelector('.js-inspiration-listing-grid');
    this.$noResults = this.$el.querySelector('.js-inspiration-listing-no-results');

    this.$verticalSelect = this.$el.querySelector('.js-inspiration-listing-vertical-select');
    this.$productSelect = this.$el.querySelector('.js-inspiration-listing-product-select');
    this.$featureSelect = this.$el.querySelector('.js-inspiration-listing-feature-select');
    this.$pageSelect = this.$el.querySelector('.js-inspiration-listing-page-select');

    this.$resetButton = this.$el.querySelector('.js-inspiration-listing-reset-filters');

    this.$verticalSelect?.addEventListener('change', this.filterByVertical.bind(this));
    this.$productSelect?.addEventListener('change', this.filterByProduct.bind(this));
    this.$featureSelect?.addEventListener('change', this.filterByFeature.bind(this));
    this.$pageSelect?.addEventListener('change', this.filterByPage.bind(this));

    this.$detailButtons = this.$el.querySelectorAll('.js-inspiration-details-button');

    this.$modal = document.querySelector('.js-inspiration-modal');
    this.$modalInner = this.$modal.querySelector('.js-inspiration-modal-inner');
    this.$modalClose = this.$modal.querySelector('.js-inspiration-modal-close');

    this.$modalImages = this.$modal.querySelector('.js-images');
    this.$modalVideo = this.$modal.querySelector('.js-video');
    this.$modalVideoEmbed = this.$modal.querySelector('.js-video-embed');
    this.$modalImage = this.$modal.querySelector('.js-inspiration-modal-image');
    this.$modalImageMobile = this.$modal.querySelector('.js-inspiration-modal-image-mobile');

    this.$modalLogo = this.$modal.querySelector('.js-inspiration-modal-logo');
    this.$modalLink = this.$modal.querySelector('.js-inspiration-modal-link');
    this.$modalIndustries = this.$modal.querySelector('.js-inspiration-modal-industries');
    this.$modalProducts = this.$modal.querySelector('.js-inspiration-modal-products');
    this.$modalFeatures = this.$modal.querySelector('.js-inspiration-modal-features');
    this.$modalPages = this.$modal.querySelector('.js-inspiration-modal-pages');
    this.$modalCaseStudyLink = this.$modal.querySelector('.js-inspiration-modal-case-study-link');

    this.$modalNext = this.$modal.querySelector('.js-inspiration-modal-next');
    this.$modalPrev = this.$modal.querySelector('.js-inspiration-modal-prev');

    this.$modalNext.addEventListener('click', this.nextModal.bind(this));
    this.$modalPrev.addEventListener('click', this.prevModal.bind(this));

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText = this.$loadMoreButton.querySelector('.c-cta__label');
      this.originalLoadMoreButtonText = this.$loadMoreButtonText.innerText;
      this.$loadMoreButton.addEventListener('click', this.loadMore.bind(this));
    }

    if (this.$resetButton) {
      this.$resetButton.addEventListener('click', this.resetFilters.bind(this));
    }

    if (this.$noResults) {
      this.$noResults.style.display = 'none';
    }

    document.addEventListener('click', e => {
      if (e.target.closest('.js-inspiration-details-button')) {
        e.preventDefault();
        const $el = e.target.closest('.js-inspiration-details-button');

        this.permalink(parseInt($el.dataset.jsonId))

        this.showDetails(parseInt($el.dataset.jsonId), $el);

        return;
      }
    });

    this.$modalClose.addEventListener('click', this.hideDetails.bind(this));

    window.addEventListener('keyup', e => {
      if (e.key === 'Escape' && this.modalOpen) {
        this.hideDetails(e);
      }
    });

    this.openPermalink()

    this.updateResetFilters();
  }

  permalink(id) {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("inspiration", id);
    history.replaceState(null, null, '?' + queryParams.toString());
  }

  clearPermalink() {
    var queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("inspiration");
    history.replaceState(null, null, '?' + queryParams.toString());
  }

  openPermalink() {
    const urlParams = new URLSearchParams(window.location.search);

    const inspiration = urlParams.get('inspiration');
    if (inspiration) {
      this.showDetails(parseInt(inspiration))
    }

    const vertical = urlParams.get('vertical');
    if (vertical) {
      this.selectedVertical = vertical;
      this.$verticalSelect.value = vertical;
    }

    const product = urlParams.get('product')
    if (product) {
      this.selectedProduct = product;
      this.$productSelect.value = product;
    }

    if (vertical || product) {
      this.filterByCategory()
    }
  }

  async execute(params, scrollToTop = true, reset = false) {
    if (reset) {
      this.currentPage = 1;
    } else {
      this.currentPage++;
    }

    this.$grid.classList.add('is-loading');

    if (this.$loadMoreButton) {
      this.$loadMoreButtonText.innerText = 'Loading';
      this.$loadMoreButton.disabled = true;
    }

    const payload = new FormData;
    payload.append('paged', this.currentPage);

    Object.keys(params).forEach(key => {
      payload.append(key, params[key]);
    });

    try {
      const { data } = await axios.post(window.site.api.ajax, payload);

      if (this.$loadMoreButton) {
        this.$loadMoreButtonText.innerText = this.originalLoadMoreButtonText;
        this.$loadMoreButton.disabled = false;

        if (data.is_last_page) {
          this.$loadMoreButton.style.display = 'none';
        } else {
          this.$loadMoreButton.style.display = 'block';
        }
      }

      if (data) {
        this.$grid.innerHTML = reset ? data.response : this.$grid.innerHTML + data.response;
        this.$grid.classList.remove('is-loading');
        this.updateResetFilters();

        if (!data.total_articles) {
          this.$grid.style.display = 'none';
          if (this.$noResults) {
            this.$noResults.removeAttribute('style');
          }

          if (this.$loadMoreButton) {
            this.$loadMoreButton.style.display = 'none';
          }
        } else {
          if (this.$noResults) {
            this.$noResults.style.display = 'none';
          }
          this.$grid.removeAttribute('style');
        }
      } else {
        if (this.$loadMoreButton) {
          this.$loadMoreButton.style.display = 'none';
        }

        this.updateResetFilters();
      }
    } catch (error) {
      this.currentPage = 1;
      this.$grid.classList.remove('is-loading');
    }
  }

  async loadMore() {
    const payload = {
      action: 'theme_inspiration_load_more',
    }

    if (this.selectedVertical) {
      payload['vertical'] = this.selectedVertical;
    }

    if (this.selectedProduct) {
      payload['product'] = this.selectedProduct;
    }

    if (this.selectedFeature) {
      payload['feature'] = this.selectedFeature;
    }

    await this.execute(payload, false);
  }

  async filterByVertical(e) {
    if (e.target.value === 'all') {
      this.selectedVertical = undefined;
    } else {
      this.selectedVertical = e.target.value;
    }

    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("vertical", this.selectedVertical);
    history.replaceState(null, null, '?' + queryParams.toString());

    await this.filterByCategory();
  }

  async filterByProduct(e) {
    if (e.target.value === 'all') {
      this.selectedProduct = undefined;
    } else {
      this.selectedProduct = e.target.value;
    }

    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("product", this.selectedProduct);
    history.replaceState(null, null, '?' + queryParams.toString());

    await this.filterByCategory();
  }

  async filterByFeature(e) {
    if (e.target.value === 'all') {
      this.selectedFeature = undefined;
    } else {
      this.selectedFeature = e.target.value;
    }

    await this.filterByCategory();
  }

  async filterByPage(e) {
    if (e.target.value === 'all') {
      this.selectedPage = undefined;
    } else {
      this.selectedPage = e.target.value;
    }

    await this.filterByCategory();
  }

  async filterByCategory(e) {
    const payload = {
      action: 'theme_inspiration_load_more',
    }

    if (this.selectedVertical) {
      payload['vertical'] = this.selectedVertical;
    }

    if (this.selectedProduct) {
      payload['product'] = this.selectedProduct;
    }

    if (this.selectedFeature) {
      payload['feature'] = this.selectedFeature;
    }

    if (this.selectedPage) {
      payload['page'] = this.selectedPage;
    }

    await this.execute(payload, true, true);
  }

  async resetFilters() {
    this.selectedVertical = undefined;
    this.selectedProduct = undefined;
    this.selectedFeature = undefined;
    this.selectedPage = undefined;

    if (this.$verticalSelect) {
      this.$verticalSelect.selectedIndex = 0;
    }

    if (this.$productSelect) {
      this.$productSelect.selectedIndex = 0;
    }

    if (this.$featureSelect) {
      this.$featureSelect.selectedIndex = 0;
    }

    const payload = {
      action: 'theme_inspiration_load_more',
    }

    await this.execute(payload, true, true);
  }

  updateResetFilters() {
    if (!this.$resetButton) return;

    if (this.currentPage > 1 || this.selectedVertical || this.selectedProduct || this.selectedFeature || this.selectedPage) {
      this.$resetButton.style.display = 'block';
    } else {
      this.$resetButton.style.display = 'none';
    }
  }

  showDetails(id, invoker) {
    this.modalOpen = true;

    document.body.classList.add('scrolling-disabled');

    this.invoker = invoker;

    this.$modal.classList.add('is-open');
    this.$modalInner.focus();
    this.$modal.setAttribute('aria-hidden', 'false');
    this.setModalData(id);
  }

  setModalData(id) {
    const modalData = window.okeInspirationModalData.find(item => item.id === id);

    this.$modalNext.dataset.jsonId = modalData.next;
    this.$modalPrev.dataset.jsonId = modalData.prev;

    this.modalData = modalData.data;

    this.$modalLogo.src = this.modalData[this.$modalLogo.dataset.json];

    if (this.modalData.modal_media === 'image') {
      this.$modalImages.classList.remove('hidden');
      this.$modalVideo.classList.add('hidden');

      this.$modalImage.src = this.modalData[this.$modalImage.dataset.json];
      this.$modalImageMobile.src = this.modalData[this.$modalImageMobile.dataset.json];
    }
    else if (this.modalData.modal_media === 'video') {
      this.$modalImages.classList.add('hidden');
      this.$modalVideo.classList.remove('hidden');

      this.$modalVideoEmbed.innerHTML = this.modalData.modal_video;

      this.$modalVideoEmbed.classList.remove('*:aspect-video');
      this.$modalVideoEmbed.classList.remove('*:aspect-fullscreen');
      this.$modalVideoEmbed.classList.remove('*:aspect-portrait');

      const aspectClass = '*:aspect-' + this.modalData.modal_video_aspect_ratio;
      this.$modalVideoEmbed.classList.add(aspectClass);
    }

    this.$modalLink.href = this.modalData[this.$modalLink.dataset.json].url;
    this.$modalLink.innerHTML = this.modalData[this.$modalLink.dataset.json].title;

    const industries = this.modalData[this.$modalIndustries.dataset.json];
    const products = this.modalData[this.$modalProducts.dataset.json];
    const features = this.modalData[this.$modalFeatures.dataset.json];
    const pages = this.modalData[this.$modalPages.dataset.json];
    const caseStudyLink = this.modalData[this.$modalCaseStudyLink.dataset.json];

    this.$modalIndustries.parentElement.classList.remove('hidden');
    this.$modalProducts.parentElement.classList.remove('hidden');
    this.$modalFeatures.parentElement.classList.remove('hidden');
    this.$modalPages.parentElement.classList.remove('hidden');
    this.$modalCaseStudyLink.classList.remove('hidden');

    if (industries) {
      this.$modalIndustries.innerHTML = this.modalData[this.$modalIndustries.dataset.json];
    } else {
      this.$modalIndustries.parentElement.classList.add('hidden');
    }

    if (products) {
      this.$modalProducts.innerHTML = this.modalData[this.$modalProducts.dataset.json];
    } else {
      this.$modalProducts.parentElement.classList.add('hidden');
    }

    if (features) {
      this.$modalFeatures.innerHTML = this.modalData[this.$modalFeatures.dataset.json];
    } else {
      this.$modalFeatures.parentElement.classList.add('hidden');
    }

    if (pages) {
      this.$modalPages.innerHTML = this.modalData[this.$modalPages.dataset.json];
    } else {
      this.$modalPages.parentElement.classList.add('hidden');
    }

    if (caseStudyLink) {
      this.$modalCaseStudyLink.href = this.modalData[this.$modalCaseStudyLink.dataset.json];
    } else {
      this.$modalCaseStudyLink.classList.add('hidden');
    }
  }

  hideDetails(e) {
    e.preventDefault();

    this.$modal.classList.remove('is-open');
    this.$modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scrolling-disabled');
    this.modalOpen = false;

    this.clearPermalink()
    this.pauseVideo()

    if (this.invoker) {
      this.invoker.focus();
    }
  }

  pauseVideo() {
    this.$modalVideoEmbed.firstChild?.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
  }

  nextModal(e) {
    e.preventDefault();
    this.pauseVideo()
    this.permalink(e.currentTarget.dataset.jsonId)
    this.setModalData(parseInt(e.currentTarget.dataset.jsonId));
  }

  prevModal(e) {
    e.preventDefault();
    this.pauseVideo()
    this.permalink(e.currentTarget.dataset.jsonId)
    this.setModalData(parseInt(e.currentTarget.dataset.jsonId));
  }
}
